<script setup>
import feather from 'feather-icons'
import { onMounted } from 'vue'
import { scrollToUp } from '@/core/utils/globals';

const date = new Date().getFullYear()

onMounted(() => {
  feather.replace()
  scrollToUp()
})

const downloadPdf = (val) => {
  const fileName = val ? 'CATALOGO PELOTAS CASA CAMPANA.pdf' : 'CATALOGO DE LICORES CASA CAMPANA.pdf'
  const filePath = `/${fileName}` // Asegúrate de que los PDFs estén en la carpeta 'public/pdf/'
  
  const link = document.createElement('a')
  link.href = filePath
  link.setAttribute('download', fileName) // Esto sugiere al navegador descargar el archivo
  document.body.appendChild(link)
  link.click();
  document.body.removeChild(link)
}
</script>
<template>
  <div>
    <!-- Footer Start -->
    <footer
      class="footer bg-dark-footer relative text-gray-200 dark:text-gray-200"
    >
      <div class="container relative">
        <div class="grid grid-cols-12">
          <div class="col-span-12">
            <div class="py-[60px] px-0">
              <div class="grid md:grid-cols-12 grid-cols-1 gap-6">
                <div class="lg:col-span-4 md:col-span-12">
                  <a href="#" class="focus:outline-none">
                    <img class="h-[50px] brightness-0 invert" src="../../assets/images/logo_light.webp" alt="" />
                  </a>
                  <p class="mt-6 text-gray-300">
                    Mejora tu estilo con nuestros conjuntos seleccionados.
                    Elige la confianza y adopta tu estilo único.
                  </p>
                  <ul class="list-none mt-6">
                    <li class="inline">
                      <a
                        href="https://www.facebook.com/shreethemes"
                        target="_blank"
                        class="size-8 inline-flex items-center justify-center tracking-wide align-middle text-base border border-gray-800 dark:border-slate-800 rounded-md hover:text-red-cc dark:hover:text-red-cc text-slate-300"
                        ><i
                          data-feather="facebook"
                          class="h-4 w-4 align-middle"
                          title="facebook"
                        ></i
                      ></a>
                    </li>
                    <li class="inline">
                      <a
                        href="https://www.instagram.com/shreethemes/"
                        target="_blank"
                        class="size-8 inline-flex items-center justify-center tracking-wide align-middle text-base border border-gray-800 dark:border-slate-800 rounded-md hover:text-red-cc dark:hover:text-red-cc text-slate-300"
                        ><i
                          data-feather="instagram"
                          class="h-4 w-4 align-middle"
                          title="instagram"
                        ></i
                      ></a>
                    </li>
                    <li class="inline">
                      <a
                        href="mailto:support@shreethemes.in"
                        class="size-8 inline-flex items-center justify-center tracking-wide align-middle text-base border border-gray-800 dark:border-slate-800 rounded-md hover:text-red-cc dark:hover:text-red-cc text-slate-300"
                        ><i
                          data-feather="mail"
                          class="h-4 w-4 align-middle"
                          title="email"
                        ></i
                      ></a>
                    </li>
                  </ul>
                  <!--end icon-->
                </div>
                <!--end col-->

                <div class="lg:col-span-5 md:col-span-12">
                  <h5 class="tracking-[1px] text-gray-100 font-semibold">
                    Compras y ropa
                  </h5>

                  <div class="grid md:grid-cols-12 grid-cols-1">
                    <div class="md:col-span-6">
                      <ul class="list-none footer-list mt-6">
                        <li class="ms-0">
                          <a
                            href=""
                            class="text-gray-300 hover:text-gray-400 duration-500 ease-in-out"
                            ><i class="mdi mdi-chevron-right"></i> Hombres</a
                          >
                        </li>
                        <li class="mt-[10px] ms-0">
                          <a
                            href=""
                            class="text-gray-300 hover:text-gray-400 duration-500 ease-in-out"
                            ><i class="mdi mdi-chevron-right"></i> Chaquetas y abrigos
                          </a>
                        </li>
                        <li class="mt-[10px] ms-0">
                          <a
                            href=""
                            class="text-gray-300 hover:text-gray-400 duration-500 ease-in-out"
                            ><i class="mdi mdi-chevron-right"></i> Jeans
                          </a>
                        </li>
                        <li class="mt-[10px] ms-0">
                          <a
                            href=""
                            class="text-gray-300 hover:text-gray-400 duration-500 ease-in-out"
                            ><i class="mdi mdi-chevron-right"></i> Trajes de baño
                          </a>
                        </li>
                        <li class="mt-[10px] ms-0">
                          <a
                            href=""
                            class="text-gray-300 hover:text-gray-400 duration-500 ease-in-out"
                            ><i class="mdi mdi-chevron-right"></i> Polos
                          </a>
                        </li>
                        <li class="mt-[10px] ms-0">
                          <a
                            href=""
                            class="text-gray-300 hover:text-gray-400 duration-500 ease-in-out"
                            ><i class="mdi mdi-chevron-right"></i> Camisas</a
                          >
                        </li>
                      </ul>
                    </div>
                    <!--end col-->

                    <div class="md:col-span-6">
                      <ul class="list-none footer-list mt-6">
                        <li class="ms-0">
                          <a
                            href=""
                            class="text-gray-300 hover:text-gray-400 duration-500 ease-in-out"
                            ><i class="mdi mdi-chevron-right"></i> Shorts
                          </a>
                        </li>
                        <li class="mt-[10px] ms-0">
                          <a
                            href=""
                            class="text-gray-300 hover:text-gray-400 duration-500 ease-in-out"
                            ><i class="mdi mdi-chevron-right"></i> Camperas
                          </a>
                        </li>
                        <li class="mt-[10px] ms-0">
                          <a
                            href=""
                            class="text-gray-300 hover:text-gray-400 duration-500 ease-in-out"
                            ><i class="mdi mdi-chevron-right"></i> Poleras
                          </a>
                        </li>
                        <li class="mt-[10px] ms-0">
                          <a
                            href=""
                            class="text-gray-300 hover:text-gray-400 duration-500 ease-in-out"
                            ><i class="mdi mdi-chevron-right"></i> Lentes para nadar
                          </a>
                        </li>
                        <li class="mt-[10px] ms-0">
                          <a
                            href=""
                            class="text-gray-300 hover:text-gray-400 duration-500 ease-in-out"
                            ><i class="mdi mdi-chevron-right"></i> Tablas</a
                          >
                        </li>
                        <li class="mt-[10px] ms-0">
                          <a
                            href=""
                            class="text-gray-300 hover:text-gray-400 duration-500 ease-in-out"
                            ><i class="mdi mdi-chevron-right"></i> Camisolas</a
                          >
                        </li>
                      </ul>
                    </div>
                    <!--end col-->

                    <!--end col-->
                  </div>
                </div>
                <div class="lg:col-span-3 md:col-span-12">
                  <div class="col-span-12">
                      <ul class="list-none footer-list mt-6">
                        <li class="ms-0">
                          <a
                            href=""
                            class="text-white hover:text-gray-400 duration-500 ease-in-out"
                            >Sobre nosotros</a
                          >
                        </li>
                        <li class="mt-[10px] ms-0">
                          <a
                            href=""
                            class="text-white hover:text-gray-400 duration-500 ease-in-out"
                            >Contacto
                          </a>
                        </li>
                        <li class="mt-[10px] ms-0">
                          <a
                            href=""
                            class="text-white hover:text-gray-400 duration-500 ease-in-out"
                            >Términos y condiciones
                          </a>
                        </li>
                        <li class="mt-[10px] ms-0">
                          <a
                            href=""
                            class="text-white hover:text-gray-400 duration-500 ease-in-out"
                            >Políticas de privacidad
                          </a>
                        </li>
                        <li class="mt-[10px] ms-0">
                          <a
                            @click.prevent="downloadPdf(true)"
                            class="text-white hover:text-gray-400 duration-500 ease-in-out cursor-pointer"
                            ><i class="mdi mdi-download"> </i> Catálogo de pelotas
                          </a>
                        </li>
                        <li class="mt-[10px] ms-0">
                          <a
                            @click.prevent="downloadPdf(false)"
                            class="text-white hover:text-gray-400 duration-500 ease-in-out cursor-pointer"
                            ><i class="mdi mdi-download"> </i> Catálogo de licores
                          </a>
                        </li>
                      </ul>
                    </div>
                </div>
              </div>
              <!--end grid-->
            </div>
            <!--end col-->
          </div>
        </div>
        <!--end grid-->
      </div>
      <!--end container-->

      <div class="py-[30px] px-0 border-t border-slate-800">
        <div class="container relative text-center">
          <div class="w-full items-center">
            <div class="md:text-start text-center">
              <p class="mb-0">
                © {{ date }} Casa Camapana. Diseñado y desarrollado
                <i class="mdi mdi-heart text-red-600"></i> by
                <a
                  href="https://shreethemes.in/"
                  target="_blank"
                  class="text-reset"
                  >World System S.A.C</a
                >.
              </p>
            </div>
          </div>
          <!--end grid-->
        </div>
        <!--end container-->
      </div>
    </footer>
    <!--end footer-->
    <!-- Footer End -->
  </div>
</template>

<style lang="scss" scoped></style>
